import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 20h1.8v-3.6H3V20zm5.4 0h1.8v-7.2H8.4V20zm10.8 0H21V2h-1.8v18zm-5.4 0h1.8V7.4h-1.8V20z"
	}), /* @__PURE__ */ _jsx("mask", {
		id: "a",
		maskUnits: "userSpaceOnUse",
		x: 3,
		y: 2,
		width: 18,
		height: 18,
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 20h1.8v-3.6H3V20zm5.4 0h1.8v-7.2H8.4V20zm10.8 0H21V2h-1.8v18zm-5.4 0h1.8V7.4h-1.8V20z",
			fill: "#fff"
		})
	})]
});
export { SvgSignal as ReactComponent };
